import ProductListingPage from "../../containers/ProductListingPage";

export const SearchPage = props => <ProductListingPage {...props} />;

export default SearchPage;
